export function ChevronRight(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M5.17424.577133c-.37408.374327-.58412.882007-.58412 1.411217 0 .5292.21004 1.03667.58412 1.41099l6.09966 6.10195c.1247.12493.1948.29423.1948.47063 0 .17638-.0701.34558-.1948.47038L5.17424 16.542c-.19619.1828-.35356.4032-.46284.6482-.10908.245-.1677.5095-.17251.7776-.00462.2682.04457.5344.14515.7831.10041.2486.24981.4746.43952.6643.18954.1896.41549.339.66421.4394.24869.1005.51496.1498.78307.1451.26819-.0047.53246-.0634.77765-.1726.24497-.1091.4653-.2665.64814-.4627l6.10197-6.1019c.8727-.8737 1.3628-2.0582 1.3628-3.29302 0-1.23481-.4901-2.41904-1.3628-3.29283L7.99663.574693C7.61942.205913 7.11262-.00044306 6.58508 7.1e-7 6.05736.0004445 5.5509.207688 5.17424.577133Z"
      />
    </svg>
  );
}
